export default {
    SET_NEWS(state, news) {
        state.news = news.items
        state.totalPages = news.total_pages
    },
    SET_HIGHLIGHTED_NEWS(state, news) {
        state.highlightedNews = news.items
    },
    SET_MAIN_NEWS(state, news) {
        state.mainNews = news.items[0] !== undefined ? news.items[0] : null
    },
    ADD_NEWS(state, news) {
        state.news.unshift(news)
    },
    UPDATE_NEWS(state, news) {
        const newsIndex = state.news.findIndex((u) => u.id === news.id)
        
        if (newsIndex >= 0) {
            Object.assign(state.news[newsIndex], news)
        }
    },
    DELETE_NEWS(state, newsId) {
        const ItemIndex = state.news.findIndex((u) => u.id === newsId)
        state.news.splice(ItemIndex, 1)
    },
    ADD_NEWS_INFOS(state, news) {
        state.newsInfos = news
    }
}
